<div mat-dialog-content>{{message}}</div>
<div mat-dialog-actions>
    <button
        mat-button
        [mat-dialog-close]="true"
    >
        Yes
    </button>
    <button
        mat-button
        (click)="onNoClick()"
        cdkFocusInitial
    >
        No
    </button>
</div>
